import React from 'react';
import PropTypes from 'prop-types';
import { Pill } from 'day8-ui';
import { FaCircleInfo } from "@react-icons/all-files/fa6/FaCircleInfo";
import { useLocation } from 'react-router-dom';
import { useAutomaticDiscounts } from '../../context/AutomaticDiscountsContext';
import { useToolipModal } from '../../context/TooltipModalContext';
import { getSelectedFilters } from '../../helpers/filter';
import { getBestCabinPromoDiscount, getPromoBookingSubjectFromLocation } from '../../helpers/promoCode';
import { getFeaturedData } from '../../helpers/week';

const DiscountPill = ({ weekId, className = "", hidden = false, isCabin = false, packageId = null, isNonStandard = false, ...props }) => {
  const { openTooltipModal } = useToolipModal();
  const location = useLocation();
  const { getDiscountForWeekAndSubject, AUTOMATIC_DISCOUNT_CAMPAIGN_DATA: globalCampaignData } = useAutomaticDiscounts();
  const campaignData = getFeaturedData(weekId)?.AUTOMATIC_DISCOUNT_CAMPAIGN_DATA || globalCampaignData;
  let discount;
  if (isCabin) {
    const { soloType, cabinType } = getSelectedFilters(location);
    const hasCabinSelection = (soloType?.length || 0) + (cabinType?.length || 0) > 0;
    discount = hasCabinSelection ? getDiscountForWeekAndSubject(weekId, getPromoBookingSubjectFromLocation(location), packageId) : getBestCabinPromoDiscount(getDiscountForWeekAndSubject, weekId, packageId);
  } else {
    discount = getDiscountForWeekAndSubject(weekId, 'yacht', packageId, isNonStandard);
  }
  const discountAmount = discount?.discountPercentage || 0;
  let bgColour;
  if (discountAmount >= 20) {
    bgColour = campaignData?.colours?.bg_dark;
  } else if (discountAmount >= 10) {
    bgColour = campaignData?.colours?.bg_dark;
  } else if (discountAmount > 0) {
    bgColour = campaignData?.colours?.bg_light;
  } else {
    bgColour = campaignData?.colours?.bg_dark; // default pill style
  }
  if (hidden || !discountAmount || discountAmount <= 0) return null;
  const tooltipModalData = isCabin ? campaignData.cabinTooltipModalData : campaignData.yachtTooltipModalData;
  return <Pill className={`${className} dui-cursor-pointer ${bgColour} dui-text-white`} type="NONE" rightIcon={<FaCircleInfo />} onClick={() => openTooltipModal(tooltipModalData)} {...props}>Claim {discountAmount}% off</Pill>;
};
DiscountPill.propTypes = {
  weekId: PropTypes.number,
  className: PropTypes.string,
  hidden: PropTypes.bool,
  isCabin: PropTypes.bool,
  packageId: PropTypes.number,
  isNonStandard: PropTypes.bool
};
export default DiscountPill;